// =========================================================
// js/approvals.js - V13.7 (STRICT COMPLETION - NO DELETIONS)
// =========================================================

window.renderApprovalsPage = function() {
    const allEvents = (window.events || []);
    const u = window.currentUser;
    if (!u) return '<div class="p-10 text-center text-slate-400">Lade Profil...</div>';

    // 1. Daten filtern
    const isPrivileged = u.role === 'OWNER' || u.role === 'ADMIN';

    // Eingang: Offen für mich (Chef oder Admin/Owner)
    const pendingTasks = allEvents.filter(e => 
        e.status === 'PENDING' && (e.reportsTo === u.uid || isPrivileged)
    );
    
    // Meine Anträge: Alles, was ich selbst eingereicht habe
    const mySubmissions = allEvents.filter(e => e.userId === u.uid)
        .sort((a, b) => new Date(b.date) - new Date(a.date));

    // Archiv: Alles Erledigte (für mich oder durch mich bearbeitet)
    const historyTasks = allEvents.filter(e => 
        e.status !== 'PENDING' && (e.processedBy === u.uid || (isPrivileged && e.status !== 'PENDING'))
    ).sort((a, b) => new Date(b.processedAt || 0) - new Date(a.processedAt || 0));

    // 2. Gelesen-Markierung für Status-Updates (Glocke)
    if (typeof statusUpdatesCache !== 'undefined' && statusUpdatesCache.length > 0) {
        statusUpdatesCache.forEach(async (event) => {
            try {
                await db.collection('companies').doc(u.companyId).collection('events').doc(event.id).update({ userNotified: true });
            } catch(e) { console.error("Update Notified State failed", e); }
        });
        statusUpdatesCache = []; 
        setTimeout(() => { if(typeof updateBellUI === 'function') updateBellUI(); }, 500);
    }

    if (!window._approvalTab) window._approvalTab = 'open';

    return `
        <div class="p-8 lg:p-12 max-w-6xl mx-auto animate-fadeIn">
            <div class="mb-10 flex flex-col md:flex-row justify-between items-end gap-6 border-b border-slate-100 pb-8">
                <div>
                    <h2 class="text-4xl font-black text-slate-800 tracking-tighter">Anfragen & Status</h2>
                    <p class="text-slate-400 font-bold uppercase tracking-widest text-[10px] mt-1">Management der Genehmigungsprozesse</p>
                </div>
                
                <div class="flex bg-slate-100 p-1.5 rounded-2xl border border-slate-200 shadow-inner">
                    <button onclick="window._approvalTab='open'; window.render()" 
                        class="px-5 py-2.5 rounded-xl font-black text-[10px] uppercase tracking-widest transition-all ${window._approvalTab === 'open' ? 'bg-white shadow-sm text-blue-600' : 'text-slate-500 hover:text-slate-700'}">
                        Eingang (${pendingTasks.length})
                    </button>
                    <button onclick="window._approvalTab='my'; window.render()" 
                        class="px-5 py-2.5 rounded-xl font-black text-[10px] uppercase tracking-widest transition-all ${window._approvalTab === 'my' ? 'bg-white shadow-sm text-blue-600' : 'text-slate-500 hover:text-slate-700'}">
                        Meine Anträge (${mySubmissions.length})
                    </button>
                    <button onclick="window._approvalTab='history'; window.render()" 
                        class="px-5 py-2.5 rounded-xl font-black text-[10px] uppercase tracking-widest transition-all ${window._approvalTab === 'history' ? 'bg-white shadow-sm text-slate-800' : 'text-slate-500 hover:text-slate-700'}">
                        Archiv
                    </button>
                </div>
            </div>

            ${window._approvalTab === 'my' ? renderMySubmissions(mySubmissions) : 
              window._approvalTab === 'history' ? renderApprovalHistory(historyTasks) : 
              renderPendingByCategories(pendingTasks)}
        </div>
    `;
};

/**
 * Hilfsfunktion: Gruppiert offene Aufgaben nach Rubriken
 */
function renderPendingByCategories(tasks) {
    if (tasks.length === 0) {
        return `<div class="p-20 text-center bg-white rounded-[3rem] border border-slate-100 text-slate-400 font-bold">Alles erledigt! Keine Aufgaben im Eingang.</div>`;
    }

    const categories = { 'Personal & Abwesenheit': [], 'Sonstiges': [] };
    tasks.forEach(t => {
        const type = (t.type || '').toLowerCase();
        if (['ho', 'homeoffice', 'vacation', 'urlaub', 'sick', 'krank'].includes(type)) {
            categories['Personal & Abwesenheit'].push(t);
        } else {
            categories['Sonstiges'].push(t);
        }
    });

    return Object.entries(categories).map(([name, list]) => list.length > 0 ? `
        <div class="mb-10 animate-fadeIn">
            <h3 class="text-[10px] font-black text-slate-300 uppercase tracking-[0.3em] mb-4 ml-4">${name}</h3>
            <div class="space-y-4">${list.map(t => renderApprovalCard(t, false)).join('')}</div>
        </div>
    ` : '').join('');
}

/**
 * Hilfsfunktion: Eigene Anträge des Users
 */
function renderMySubmissions(tasks) {
    if (tasks.length === 0) return `<div class="p-20 text-center bg-white rounded-[3rem] border border-slate-100 text-slate-400 font-bold">Du hast noch keine Anträge gestellt.</div>`;
    return `
        <div class="space-y-4 animate-fadeIn">
            <h3 class="text-[10px] font-black text-slate-300 uppercase tracking-[0.3em] mb-6 ml-4">Status deiner Einreichungen</h3>
            ${tasks.map(t => renderApprovalCard(t, true)).join('')}
        </div>`;
}

/**
 * Hilfsfunktion: Abgeschlossene Vorgänge
 */
function renderApprovalHistory(tasks) {
    if (tasks.length === 0) return `<div class="p-20 text-center bg-white rounded-[3rem] border border-slate-100 text-slate-400 font-bold">Archiv leer.</div>`;
    return `
        <div class="space-y-4 animate-fadeIn">
            <h3 class="text-[10px] font-black text-slate-300 uppercase tracking-[0.3em] mb-6 ml-4">Letzte Entscheidungen</h3>
            ${tasks.slice(0, 50).map(t => renderApprovalCard(t, true)).join('')}
        </div>`;
}

/**
 * Zentrale Karten-Komponente für einen Antrag
 */
function renderApprovalCard(task, isHistory) {
    const applicant = (window.usersList || []).find(u => u.uid === task.userId) || { firstName: 'Nutzer', lastName: '' };
    const style = (typeof window.getEventStyle === 'function') ? window.getEventStyle(task.type) : { color: 'blue', icon: 'calendar', name: 'Antrag' };
    
    const isApproved = task.status === 'APPROVED';
    const isRejected = task.status === 'REJECTED';
    const initials = (applicant.firstName?.[0] || '') + (applicant.lastName?.[0] || '');

    // CSRD: Impact-Wert (Snapshot)
    const impactVal = task.co2SavedAtBooking || 0;

    return `
        <div class="bg-white border border-slate-100 rounded-[2.5rem] p-6 flex flex-col lg:flex-row items-center gap-6 shadow-sm hover:shadow-md transition-all relative overflow-hidden group">
            ${isHistory ? `<div class="absolute top-0 left-0 w-2 h-full ${isApproved ? 'bg-emerald-500' : isRejected ? 'bg-rose-500' : 'bg-orange-400'}"></div>` : ''}
            
            <div class="flex items-center gap-4 min-w-[200px]">
                <div class="w-12 h-12 bg-slate-50 text-slate-400 border border-slate-100 rounded-2xl flex items-center justify-center font-black text-xs shrink-0 group-hover:bg-blue-50 group-hover:text-blue-600 transition-colors">
                    ${initials}
                </div>
                <div class="overflow-hidden">
                    <h4 class="font-black text-slate-800 truncate">${applicant.firstName} ${applicant.lastName}</h4>
                    <span class="text-[9px] font-black text-slate-400 uppercase tracking-widest flex items-center gap-1">
                        <i data-lucide="${style.icon}" class="w-3 h-3"></i> ${style.name}
                    </span>
                </div>
            </div>

            <div class="flex-1 w-full bg-slate-50/50 p-4 rounded-2xl border border-slate-100">
                <div class="flex items-center justify-between mb-1">
                    <p class="text-[10px] font-black text-slate-400 uppercase tracking-tighter">Datum: ${task.date}</p>
                    ${impactVal > 0 ? `<span class="bg-emerald-50 text-emerald-600 px-2.5 py-1 rounded-lg text-[8px] font-black uppercase border border-emerald-100">Impact: ${impactVal.toFixed(1)}kg CO₂</span>` : ''}
                </div>
                <p class="text-slate-600 text-sm italic font-medium">"${task.comment || task.requestReason || '-'}"</p>
                ${isHistory && task.approverComment ? `<p class="text-[10px] text-rose-500 font-bold mt-2 border-t border-rose-100 pt-1">Notiz: ${task.approverComment}</p>` : ''}
            </div>

            <div class="flex items-center gap-3 w-full lg:w-auto">
                ${!isHistory ? `
                    <button onclick="window.processApprovalTask('${task.id}', 'APPROVED')" class="flex-1 lg:flex-none bg-emerald-600 text-white px-6 py-3 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-black transition-all shadow-lg shadow-emerald-100">Genehmigen</button>
                    <button onclick="window.processApprovalTask('${task.id}', 'REJECTED')" class="flex-1 lg:flex-none bg-white border border-slate-200 text-rose-500 px-6 py-3 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-rose-50 transition-all">Ablehnen</button>
                ` : `
                    <div class="text-right min-w-[100px]">
                        <p class="text-[10px] font-black text-slate-300 uppercase tracking-widest">Entscheidung</p>
                        <p class="text-xs font-bold ${isApproved ? 'text-emerald-600' : isRejected ? 'text-rose-600' : 'text-orange-500'}">${task.status}</p>
                    </div>
                `}
            </div>
        </div>
    `;
}

/**
 * Logik zum Verarbeiten eines Antrags
 */
window.processApprovalTask = async function(eventId, newStatus) {
    let comment = "";
    if (newStatus === 'REJECTED') {
        comment = prompt("Grund für die Ablehnung (optional):");
        if (comment === null) return; 
    }

    try {
        const cid = window.currentUser.companyId;
        await db.collection('companies').doc(cid).collection('events').doc(eventId).update({
            status: newStatus,
            processedAt: new Date().getTime(),
            processedBy: window.currentUser.uid,
            approverComment: comment
        });

        if (window.showToast) window.showToast("Anfrage wurde erfolgreich aktualisiert.");
        if (typeof window.loadInitialData === 'function') await window.loadInitialData();
    } catch (e) { 
        alert("Fehler beim Verarbeiten: " + e.message); 
    }
};